import React, { useState, useEffect, useMemo } from "react";
import * as configApi from "../../../config/configApi.js";
import ReactTable from "react-table";
import { withFixedColumnsStickyPosition } from "react-table-hoc-fixed-columns";
import { Card, CardBody } from "reactstrap";
import { ColorResult } from "../../../../src/Constant";

const ReactTableFixedColumns = withFixedColumnsStickyPosition(ReactTable);

const Ordinary = ({ t, data }) => {
  const [processedData, setProcessedData] = useState([]);
  const primaryColor = configApi.USE_COLOR;

  useEffect(() => {
    if (data?.listOrder?.length > 0) {
      const result = processDataToView(data.listOrder);
      console.log(result);
      setProcessedData(result);
    }
  }, [data]);

  const processDataToView = (orders) => {
    const groupedByCategory = new Map();

    orders.forEach((order) => {
      order.listTestOrder?.forEach((test) => {
        if (!groupedByCategory.has(test.categoryId)) {
          groupedByCategory.set(test.categoryId, []);
        }
        groupedByCategory.get(test.categoryId).push(test);
      });
    });

    const viewData = [];
    let index = 1;

    for (const [categoryId, tests] of groupedByCategory.entries()) {
      // Header row for category
      const firstTest = tests[0];
      viewData.push({
        stt: "",
        categoryId: categoryId,
        TenXN: firstTest.categoryName,
        KetQua: "",
        DonVi: "",
        CSBT: "",
        color: 0,
        levelLable: 1,
      });

      // Detail rows (levelLable 2 and 3)
      tests.forEach((test) => {
        viewData.push({
          stt: index++,
          categoryId: categoryId,
          TenXN: test.testName,
          KetQua: test.result,
          DonVi: test.unit,
          CSBT: test.normalRange,
          color: test.color,
          levelLable: 2,
        });

        test.listSubTest?.forEach((sub) => {
          viewData.push({
            stt: "",
            categoryId: sub.categoryId,
            TenXN: sub.testName,
            KetQua: sub.result,
            DonVi: sub.unit,
            CSBT: sub.normalRange,
            color: sub.color,
            levelLable: 3,
          });
        });
      });
    }

    return viewData;
  };

  const Columns = useMemo(
    () => [
      {
        filterable: false,
        resizable: false,
        sortable: false,
        width: 50,
        Header: t("No."),
        accessor: "stt",
        Cell: ({ value }) => {
          const stt = value ? value.toString() : "";
          return (
            <div
              style={{ width: "100%", textAlign: "center" }}
            >
              {stt}
            </div>
          );
        },
        headerStyle: {
          color: primaryColor,
        },
      },
      {
        Header: t("Testname"),
        filterable: false,
        accessor: "TenXN",
        width: 480,
        Cell: ({ value, row }) => {
          const valuedis = value ? value.toString() : "";
          const original = row._original;

          if (original.levelLable === 1) {
            return (
              <div
                style={{
                  width: "100%",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  color: primaryColor,
                }}
              >
                {valuedis}
              </div>
            );
          } else if (original.levelLable === 2) {
            return (
              <div
                style={{ width: "100%", paddingLeft: "5%" }}
              >
                {valuedis}
              </div>
            );
          } else {
            return (
              <div style={{ width: "100%", paddingLeft: "10%" }}>
                {valuedis}
              </div>
            );
          }
        },
        headerStyle: {
          color: primaryColor,
        },
      },

      {
        Header: t("Result"),
        filterable: false,
        accessor: "KetQua",
        width: 150,
        Cell: ({ value, row }) => {
          const KetQua = value ? value.toString() : "";
          const colorCode =
            ColorResult.find((c) => c.value === row._original?.color)?.label ||
            "black";

          return (
            <div
              style={{
                width: "100%",
                textAlign: "center",
                fontWeight: (row._original?.color > 0 ? "bold" : "normal"),
                color: colorCode,
              }}
            >
              {KetQua}
            </div>
          );
        },
        headerStyle: {
          color: primaryColor,
        },
      },
      {
        Header: t("Unit"),
        filterable: false,
        accessor: "DonVi",
        width: 100,
        headerStyle: {
          color: primaryColor,
        },
      },
      {
        Header: t("CSBT"),
        filterable: false,
        accessor: "CSBT",
        width: 170,
        headerStyle: {
          color: primaryColor,
        },
      },
    ],
    [t, primaryColor]
  );

  return (
    <>
      <div style={{ margin: "5px 0" }}>
        <b>{t("RESULT OF TESTS")}</b>
      </div>
      <ReactTableFixedColumns
        data={processedData}
        pageSize={processedData.length > 10 ? processedData.length : 10}
        filterable={false}
        columns={Columns}
        showPagination={false}
        noDataText={t("No data")}
        className="-striped -highlight -fixed"
        style={{ height: "calc(100vh - 420px)" }}
      />
    </>
  );
};

export default Ordinary;
